module.exports = __webpack_public_path__ + "img/lang-pt-hover.96e8f486.png";